<template>
  <label :class="classes" class="checkbox">
    <input
      v-bind="$attrs"
      :checked="checked"
      :required="required"
      class="checkbox__input"
      type="checkbox"
      @change="handleChange"
    />
    <span class="checkbox__checkmark" />
    <slot />
  </label>
</template>

<script>
import { without } from 'lodash';
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [Array, Boolean],
      required: false,
      default: false
    },
    value: {
      type: [Boolean, String, Number],
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    checked() {
      if (this.isGroup) {
        return this.modelValue.includes(this.value);
      }
      return this.modelValue;
    },
    classes() {
      return {
        'is-checked': this.checked
      };
    },
    isGroup() {
      return Array.isArray(this.modelValue);
    }
  },
  methods: {
    getValue(checked) {
      if (this.isGroup) {
        if (checked) {
          return [...this.modelValue, this.value];
        } else {
          return without(this.modelValue, this.value);
        }
      }
      return checked;
    },
    handleChange(event) {
      const value = this.getValue(event.target.checked);
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  @include font-size('paragraph', 'md');
  align-items: center;
  display: flex;
  margin-bottom: spacing('sm');
  transition: color 0.2s;

  &__checkmark {
    align-items: center;
    background-color: transparent;
    border: solid 1px shade('white', 10%);
    display: flex;
    flex-shrink: 0;
    height: 1.8rem;
    justify-content: center;
    margin-right: spacing('sm');
    transition: background-color 0.2s, border-color 0.2s;
    width: 1.8rem;

    &::after {
      border: solid color('white');
      border-width: 0 0.2rem 0.2rem 0;
      content: '';
      height: 1rem;
      transform: rotate(45deg) translateY(-0.1rem);
      width: 0.5rem;
    }
  }

  &:hover {
    color: color('primary');

    .checkbox__checkmark {
      border-color: color('primary');
    }
  }

  &__input {
    cursor: pointer;
    height: 0;
    opacity: 0;
    position: absolute;
    width: 0;

    &:checked + .checkbox__checkmark {
      background-color: color('primary');
      border-color: color('primary');

      &::after {
        display: block;
      }
    }
  }
}
</style>
